import { IconProps } from "../../../types/style";

const ActiveListSVG = (prop: IconProps) => {
  const { color = "#f5f5f5", size = 24 } = prop;
  return (
    <div style={{ height: size + "px" }}>
      <svg
        width="20"
        height="16"
        viewBox="0 0 3 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect y="0.5" width="3" height="15" rx="1.5" fill="white" />
      </svg>
    </div>
  );
};

export default ActiveListSVG;
